import React from 'react';
import apiurl from '../apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import PanelKonf from './PanelKonf';




export default class Konfiguracja extends React.Component {

constructor(props) {
  super();    

  this.state = {
    rok: props.rok,
    token: props.token,
    loadingKonfig: true,
    years: [],
    typ: 1,
  };
}

componentDidMount() {
  this.getYears();
  this.getKonfig();
}

getKonfig = () => {
  axios.get(apiurl+"api/ewConfig", {  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => this.setState({ konfigData: response.data, loadingKonfig: false }) )
    .catch(error => swal(error.response.data), this.setState({ loadingKonfig: false}) );
}

getYears() {
  axios.get(apiurl+"api/Listy/getYears", { headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => { this.setState({ years : res.data }) })
    .catch(error => console.log('Error - loading years'));
}

refreshKonfig = () => {
  axios.get(apiurl+"api/Konfig", {params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => {
      sessionStorage.setItem("konfig", JSON.stringify(response.data));
    })
    .catch(error => console.log('Error - refresh config'));
}



render() {

  const { loadingKonfig, konfigData, token, years, typ } = this.state;

  return (<>
    <div className="container-fluid">
      <h2>Konfiguracja</h2>
 
      <hr /> 

      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a className={typ === 1 ? "nav-link pointer active" : "nav-link pointer"} onClick={() => (this.setState({ typ: 1 }))} >Dokumenty</a>
        </li>
        <li className="nav-item"> 
          <a className={typ === 2 ? "nav-link pointer active" : "nav-link pointer"} onClick={() => (this.setState({ typ: 2 }))} >Uwagi / Opinie</a>
        </li>
        <li className="nav-item">
          <a className={typ === 3 ? "nav-link pointer active" : "nav-link pointer"} onClick={() => (this.setState({ typ: 3 }))} >Zestawienia</a>
        </li>
        <li className="nav-item">
          <a className={typ === 4 ? "nav-link pointer active" : "nav-link pointer"} onClick={() => (this.setState({ typ: 4 }))} >Inne</a>
        </li>
      </ul>
      
      {loadingKonfig && <center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>}

      <div className="accordion" id="konfigCards">
        {konfigData?.filter((val) => val.typKonfiguracji === typ)
        .map((dane, idx) => <PanelKonf token={token} dane={dane} years={years} idx={idx} refreshKonfig={this.refreshKonfig} /> )}
      </div>

    </div>
  </>)}
}

